import { VAnmeldelseUtkast } from "../valideringstyper/domenetyper/anmeldelseUtkast";

const valideringsmeldinger: VAnmeldelseUtkast = {
  anmeldelseType: {
    en: {
      av: "Unable to submit a report of this type. Please create a report as one of the following types: {{messageParams.values, anmeldelse_type_list_formatter}}",
    },
  },
  samtykkeInformasjon: {
    ikke: {
      null: "You must answer whether you consent to the collection of information or not",
    },
    samtykkeInnhentingAvOpplysninger: {
      ikke: {
        null: "You must answer whether you consent to the collection of information or not",
      },
    },
  },
  fornaermet: {
    konfliktraadinformasjon: {
      ikke: {
        null: "You must answer whether the victim is willing to handle the case in the Norwegian Mediation Service",
      },
      fornaermetVilligTilKonfliktraad: {
        ikke: {
          null: "You must answer whether the victim is willing to handle the case in the Norwegian Mediation Service",
        },
      },
    },
    person: {
      ikke: {
        null: "You must provide a victim",
      },
      anmeldersRelasjonTilFornaermetPerson: {
        ikke: {
          null: "You must provide your affiliation with the enterprise",
        },
      },
      anmeldersRelasjonTilFornaermetPersonAnnenBeskrivelse: {
        ikke: {
          null: "You must provide a description of your relationship to the victim",
          blank: "Cannot consist of only blank characters",
        },
        maks: {
          lengde: "Description of relationship to the victim is too long",
        },
      },
      kontaktopplysninger: {
        ikke: {
          null: "You must provide contact information for the victim",
        },
        epost: {
          ikke: {
            null: "You must provide an email address",
          },
          gyldig: {
            epost: "You must provide a valid email address",
          },
          maks: {
            lengde:
              "The email address is too long, the maximum length is {{messageParams.maxLength}} characters.",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "You must provide a valid phone number.",
          },
          ikke: {
            null: "You must provide a phone number",
          },
          maks: {
            lengde:
              "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
          },
        },
      },
      navn: {
        ikke: {
          null: "You must provide a name",
        },
        etternavn: {
          ikke: {
            null: "You must provide a last name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Last name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        fornavn: {
          ikke: {
            null: "You must provide a first name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "First name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        mellomnavn: {
          ikke: {
            null: "You must provide a middle name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Middle name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "You must provide birth or D-number.",
        },
        gyldig: {
          foedselsEllerDnummer:
            "This is not a valid Norwegian birth or D-number",
        },
      },
      beskrivelse: {
        maks: {
          lengde: "Description of victim is too long",
        },
        ikke: {
          blank: "Cannot consist of only blank characters",
        },
      },
    },
    virksomhet: {
      anmeldersRelasjonTilFornaermetVirksomhet: {
        ikke: {
          null: "You must provide your affiliation with the enterprise",
        },
      },
      anmeldersRelasjonTilFornaermetVirksomhetAnnenBeskrivelse: {
        maks: {
          lengde:
            "The description is too long, maximum length is {{messageParams.maxLength}} characters",
        },
        ikke: {
          null: "You must provide an affiliation with the enterprise",
          blank: "The affiliation cannot consist of only blank characters.",
        },
      },
      ikke: {
        null: "You have to choose who is the victim",
      },
      maaFylleUtVirksomhet: "You have to choose who is the victim",
      vekterSelskap: {
        maaFylleUtVirksomhet:
          "You must choose which security company you work for",
      },
      virksomhetensReferanse: {
        ikke: {
          blank:
            "The enterprise reference cannot consist of only blank characters",
        },
        maks: {
          lengde:
            "The enterprise reference is too long, the maximum length is {{messageParams.maxLength}} characters.",
        },
        begrensetTegnsett:
          "The enterprise reference has invalid characters, {{messageParams.ugyldigeTegn}} is not allowed",
      },
      samtykkeVirksomhetKanSeAnmeldelsen: {
        ikke: {
          null: "You must answer whether you want to send a copy of the report to the enterprise or not",
        },
      },
    },
    type: {
      ikke: {
        null: "You must state who is the victim of the crime",
      },
      en: {
        av: "Invalid victim type selected",
      },
    },
  },
  vedlegg: {
    metadata: {
      root: {
        maks: {
          size: "You cannot upload more than {{messageParams.maxSize}} files",
        },
        passordbeskyttetFil:
          "The file is password protected, please remove the password and upload the file again",
        forMangeSider:
          "The file has over 15000 pages, please reduce the number of pages and upload the file again",
        korruptFil:
          "We cannot process the file you have uploaded. It may help to export the file in another format and try again.",
        duplikat: {
          fil: "File with equal name or content has already been uploaded under $t({{propertyPath}}_lokasjon.{{messageParams.kontekst}}). Please change the file name or choose another one.",
          fil_lokasjon: {
            ANMELDELSE: "the attachments step",
            ERSTATNINGSKRAV_VEDLEGG: "compensation claim",
            ERSTATNINGSKRAV_FULLMAKT: "power of attorney",
          },
        },
      },
      opplastet: {
        true: "The attached file has not been uploaded, if the error persists, try uploading the file again.",
      },
      checksum: {
        feilVedOpplasting:
          "An error occurred while uploading the file, please try again",
      },
      filendelse: {
        gyldig: {
          mimetype:
            "The file cannot be uploaded because the file type does not match the content of the file",
          filtype:
            "We do not support this file type, supported file types are {{AKSEPTERTE_FILER_STRING}}",
        },
      },
      malwareScanStatus: {
        malwareScanIkkeOk:
          "This file was stopped by our virus scan and must be removed in order to submit the report",
      },
      stoerrelse: {
        ikke: {
          tom: "The file is empty, please upload a non-empty file",
        },
        filstoerrelse: {
          maks: "The file is too large, it cannot be larger than {{messageParams.maksFilstoerrelseString}}",
          totalt:
            "Total file size must be less than {{messageParams.maksFilstoerrelseString}}",
        },
      },
      filnavn: {
        gyldig: {
          verdi: "The file name is not valid. Avoid using special characters.",
        },
        maks: {
          lengde:
            "The file name is too long, the maximum length is {{messageParams.maxLength}} characters",
        },
        ikke: {
          blank: "The file name cannot consist of only blank characters.",
        },
      },
      opplastetBytes: {
        feilVedOpplasting:
          "An error occurred while uploading the file, please try again",
      },
    },
    beskrivelse: {
      maks: {
        lengde:
          "The description is too long, maximum length is {{messageParams.maxLength}} characters",
      },
      ikke: {
        blank: "The description cannot consist of only empty characters",
      },
    },
  },
  hendelsestidspunkt: {
    fra: {
      dato: {
        mindre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              now: "From date cannot be later than today's date and time",
            },
          },
        },
        stoerre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              til: "From date cannot be more than 50 years ago",
            },
          },
        },
      },
      ikke: {
        null: "You must provide the date and time of when the incident started",
      },
    },
    til: {
      dato: {
        mindre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              now: "To date cannot be later than today's date and time",
            },
          },
        },
        stoerre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              fra: "To date cannot be earlier than from date",
            },
          },
        },
      },
    },
  },
  experimentalFields: {
    experimentalGjerningsaktorInformasjon: {
      ikke: {
        null: "You must answer if you have information about the alleged perpetrator",
      },
      gjerningsaktorErKjent: {
        ikke: {
          null: "You must answer if you have information about the alleged perpetrator",
        },
      },
      gjerningsaktorer: {
        maks: {
          size: "You cannot add more than one enterprise",
        },
        ikke: {
          tom: "You must add a perpetrator",
        },
        begrunnelseForInvolvering: {
          ikke: {
            blank: "The justification cannot consist of only empty characters",
            null: "You must justify why you believe the perpetrator is involved",
          },
          maks: {
            lengde:
              "Justification text is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        gjerningsvirksomhet: {
          ikke: {
            null: "You must add an enterprise",
          },
          orgnummer: {
            ikke: {
              null: "You must provide the organization number",
            },
          },
          navn: {
            ikke: {
              null: "You must provide the name of the enterprise",
            },
          },
          manuellVirksomhet: {
            navn: {
              ikke: {
                null: "You must provide the name of the enterprise",
                blank:
                  "The enterprise name cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "The enterprise name is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
            informasjonselementer: {
              verdi: {
                mangler: {
                  verdiForInformasjonselement:
                    "You must fill in the value for this field",
                  verdiForInformasjonselement_EPOST:
                    "You must provide an email address",
                  verdiForInformasjonselement_TELEFON:
                    "You must provide a phone number",
                  verdiForInformasjonselement_ADRESSE:
                    "You must provide an address",
                  verdiForInformasjonselement_NETTSTED:
                    "You must provide a website",
                  verdiForInformasjonselement_ORGNR:
                    "You must provide an organisation number",
                  verdiForInformasjonselement_ANNET: "You must provide a value",
                },
                gyldig: {
                  epost: "You must provide a valid email address",
                  telefonnummer: "You must provide a valid phone number",
                  nettstedsadresse: "You must provide a valid website address",
                },
                maks: {
                  lengde:
                    "The value is too long, maximum length is {{messageParams.maxLength}} characters",
                },
                ikke: {
                  null: "You must fill in the value for this field",
                  blank: "The field cannot consist of only blank characters",
                },
              },
            },
          },
        },
        gjerningsperson: {
          root: {
            minstEnInfoGjerningsperson:
              "You must add at least one type of information",
          },
          personopplysninger: {
            minstEnInfoGjerningsperson:
              "You must add at least one personal detail",
          },
          ikke: {
            null: "You must add a perpetrator",
          },
          foedselsEllerDnummer: {
            ikke: {
              null: "You must provide birth or D-number.",
            },
            gyldig: {
              foedselsEllerDnummer:
                "This is not a valid Norwegian birth or D-number",
            },
          },
          foedselsdato: {
            dato: {
              mindre: {
                eller: {
                  lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
                  lik_comparison: {
                    now: "Date of birth cannot be set to a future date",
                  },
                },
              },
            },
          },
          personnavn: {
            ikke: {
              null: "You must provide a name",
            },
            etternavn: {
              ikke: {
                null: "You must provide a last name",
                blank: "Cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Last name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            fornavn: {
              ikke: {
                null: "You must provide a first name",
                blank: "Cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "First name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            mellomnavn: {
              ikke: {
                null: "You must provide a middle name",
                blank: "Cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Middle name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
          },
          ekstraKontaktopplysninger: {
            typeKontaktopplysning: {
              ikke: {
                null: "You must specify what type of contact information it is",
              },
            },
            verdi: {
              gyldig: {
                telefonnummer: "You must provide a valid phone number.",
                epost: "You must provide a valid email address",
              },
              ikke: {
                null: "You must provide contact information",
                blank:
                  "The contact information cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "The contact information is too long, max length is {{messageParams.maxLength}} characters",
              },
              mangler: {
                verdiForKontaktopplysning:
                  "You must provide contact information",
                verdiForKontaktopplysning_TELEFONNUMMER:
                  "You must provide a phone number",
                verdiForKontaktopplysning_EPOST:
                  "You must provide an email address",
                verdiForKontaktopplysning_BRUKERNAVN:
                  "You must provide a username",
                verdiForKontaktopplysning_ADRESSE:
                  "You must provide an address",
                verdiForKontaktopplysning_ANNET: "You must provide a value",
              },
            },
            context: {
              ikke: {
                null: "You must provide context for the contact information",
                blank:
                  "Context description cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Context description is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
          },
          personBeskrivelse: {
            ikke: {
              blank: "The description cannot consist of only empty characters",
            },
            maks: {
              lengde:
                "Description of perpetrator is too long, maximum length is {{messageParams.maxLength}} characters",
            },
          },
          gjerningspersonErMyndig: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              foedselsdato: "Age must match date of birth",
              foedselsnummer: "Age must match national identity number",
            },
            ikke: {
              null: "You must provide the age of the perpetrator.",
            },
          },
          identifiseringsinformasjon: {
            beskrivelse: {
              ikke: {
                blank:
                  "The description cannot consist of only empty characters",
                null: "You must describe how you identified the perpetrator",
              },
              maks: {
                lengde:
                  "The description of the id is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            ikke: {
              null: "You must choose a method of identification",
            },
            metode: {
              ikke: {
                null: "You must choose a method of identification",
              },
            },
          },
          verge: {
            kontaktopplysninger: {
              epost: {
                ikke: {
                  null: "You must provide an email address",
                },
                gyldig: {
                  epost: "You must provide a valid email address",
                },
                maks: {
                  lengde:
                    "The email address is too long, the maximum length is {{messageParams.maxLength}} characters.",
                },
              },
              telefonnummer: {
                gyldig: {
                  telefonnummer: "You must provide a valid phone number.",
                },
                ikke: {
                  null: "You must provide a phone number",
                },
                maks: {
                  lengde:
                    "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
                },
              },
            },
            personnavn: {
              ikke: {
                null: "You must provide a name",
              },
              etternavn: {
                ikke: {
                  null: "You must provide a last name",
                  blank: "Last name cannot consist of only blank characters",
                },
                maks: {
                  lengde:
                    "Last name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              fornavn: {
                ikke: {
                  null: "You must provide a first name",
                  blank: "First name cannot consist of only blank characters",
                },
                maks: {
                  lengde:
                    "First name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              mellomnavn: {
                ikke: {
                  null: "You must provide a middle name",
                  blank: "Middle name cannot consist of only blank characters",
                },
                maks: {
                  lengde:
                    "Middle name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
            vergeErKontaktet: {
              ikke: {
                null: "You must answer whether you have contacted the legal guardian",
              },
            },
            vergeTilStede: {
              ikke: {
                null: "You must answer whether the legal guardian arrived at the scene",
              },
            },
          },
          oppgitteOpplysninger: {
            personnavn: {
              ikke: {
                null: "You must provide a name",
              },
              etternavn: {
                ikke: {
                  null: "You must provide a last name",
                  blank: "Cannot consist of only blank characters",
                },
                maks: {
                  lengde:
                    "Last name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              fornavn: {
                ikke: {
                  null: "You must provide a first name",
                  blank: "Cannot consist of only blank characters",
                },
                maks: {
                  lengde:
                    "First name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              mellomnavn: {
                ikke: {
                  null: "You must provide a middle name",
                  blank: "Cannot consist of only blank characters",
                },
                maks: {
                  lengde:
                    "Middle name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
            virksomhetNavn: {
              ikke: {
                blank: "Enterprise cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Enterprise name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            andreOpplysninger: {
              ikke: {
                blank:
                  "Other information cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Other information is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
          },
        },
      },
    },
  },
  gjerningspersonInformasjon: {
    gjerningspersoner: {
      foedselsdato: {
        dato: {
          mindre: {
            eller: {
              lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
              lik_comparison: {
                now: "Date of birth cannot be set to a future date",
              },
            },
          },
        },
      },
      gjerningspersonErMyndig: {
        lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
        lik_comparison: {
          foedselsdato: "Age must match date of birth",
          foedselsnummer: "Age must match national identity number",
        },
        ikke: {
          null: "You must provide the age of the perpetrator.",
        },
      },
      begrunnelseForInvolvering: {
        ikke: {
          blank: "The description cannot consist of only empty characters",
          null: "You must justify why you believe the perpetrator is involved",
        },
        maks: {
          lengde:
            "Justification text is too long, max length is {{messageParams.maxLength}} characters",
        },
      },
      personBeskrivelse: {
        ikke: {
          blank: "The description cannot consist of only empty characters",
        },
        maks: {
          lengde:
            "Description of perpetrator is too long, maximum length is {{messageParams.maxLength}} characters",
        },
      },
      identifiseringsinformasjon: {
        beskrivelse: {
          ikke: {
            blank: "The description cannot consist of only empty characters",
            null: "You must describe how you identified the perpetrator",
          },
          maks: {
            lengde:
              "The description of the id is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        ikke: {
          null: "You must choose a method of identification",
        },
        metode: {
          ikke: {
            null: "You must choose a method of identification",
          },
        },
      },
      root: {
        minstEnInfoGjerningsperson:
          "You must fill in at least one of the fields",
      },
      ikke: {
        tom: "You must add a perpetrator",
      },
      kontaktopplysninger: {
        epost: {
          ikke: {
            null: "You must provide an email address",
          },
          gyldig: {
            epost: "You must provide a valid email address",
          },
          maks: {
            lengde:
              "The email address is too long, the maximum length is {{messageParams.maxLength}} characters.",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "You must provide a valid phone number.",
          },
          ikke: {
            null: "You must provide a phone number",
          },
          maks: {
            lengde:
              "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
          },
        },
      },
      ekstraKontaktopplysninger: {
        typeKontaktopplysning: {
          ikke: {
            null: "You must specify what type of contact information it is",
          },
        },
        verdi: {
          gyldig: {
            telefonnummer: "You must provide a valid phone number.",
            epost: "You must provide a valid email address",
          },
          ikke: {
            null: "You must provide contact information",
            blank:
              "The contact information cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "The contact information is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        context: {
          ikke: {
            null: "You must provide context for the contact information",
            blank:
              "Context description cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Context description is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
      },
      verge: {
        kontaktopplysninger: {
          epost: {
            ikke: {
              null: "You must provide an email address",
            },
            gyldig: {
              epost: "You must provide a valid email address",
            },
            maks: {
              lengde:
                "The email address is too long, the maximum length is {{messageParams.maxLength}} characters.",
            },
          },
          telefonnummer: {
            gyldig: {
              telefonnummer: "You must provide a valid phone number.",
            },
            ikke: {
              null: "You must provide a phone number",
            },
            maks: {
              lengde:
                "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
            },
          },
        },
        personnavn: {
          ikke: {
            null: "You must provide a name",
          },
          etternavn: {
            ikke: {
              null: "You must provide a last name",
              blank: "Cannot consist of only blank characters",
            },
            maks: {
              lengde:
                "Last name is too long, max length is {{messageParams.maxLength}} characters",
            },
          },
          fornavn: {
            ikke: {
              null: "You must provide a first name",
              blank: "Cannot consist of only blank characters",
            },
            maks: {
              lengde:
                "First name is too long, max length is {{messageParams.maxLength}} characters",
            },
          },
          mellomnavn: {
            ikke: {
              null: "You must provide a middle name",
              blank: "Cannot consist of only blank characters",
            },
            maks: {
              lengde:
                "Middle name is too long, max length is {{messageParams.maxLength}} characters",
            },
          },
        },
        vergeErKontaktet: {
          ikke: {
            null: "You must answer whether you have contacted the legal guardian",
          },
        },
        vergeTilStede: {
          ikke: {
            null: "You must answer whether the legal guardian arrived at the scene",
          },
        },
      },
      personnavn: {
        ikke: {
          null: "You must provide a name",
        },
        etternavn: {
          ikke: {
            null: "You must provide a last name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Last name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        fornavn: {
          ikke: {
            null: "You must provide a first name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "First name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        mellomnavn: {
          ikke: {
            null: "You must provide a middle name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Middle name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "You must provide birth or D-number.",
        },
        gyldig: {
          foedselsEllerDnummer:
            "This is not a valid Norwegian birth or D-number",
        },
      },
      harVergesKontaktinformasjon: {
        ikke: {
          null: "You must answer if you have the legal guardian's contact information",
        },
      },
    },
    gjerningspersonErKjent: {
      ikke: {
        null: "You must answer if you have information about the alleged perpetrator",
      },
    },
  },
  vitneInformasjon: {
    andreVitner: {
      foedselsdato: {
        dato: {
          mindre: {
            eller: {
              lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
              lik_comparison: {
                now: "Date of birth cannot be set to a future date",
              },
            },
          },
        },
      },
      personBeskrivelse: {
        ikke: {
          blank: "The description cannot consist of only empty characters",
        },
        maks: {
          lengde:
            "Witness description is too long, max length is {{messageParams.maxLength}} characters",
        },
      },
      ikke: {
        tom: "You must add at least one witness",
      },
      root: {
        minstEnInfoVitne: "You must fill in at least one of the fields",
      },
      kontaktopplysninger: {
        epost: {
          ikke: {
            null: "You must provide an email address",
          },
          gyldig: {
            epost: "You must provide a valid email address",
          },
          maks: {
            lengde:
              "The email address is too long, the maximum length is {{messageParams.maxLength}} characters.",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "You must provide a valid phone number.",
          },
          ikke: {
            null: "You must provide a phone number",
          },
          maks: {
            lengde:
              "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
          },
        },
      },
      personnavn: {
        ikke: {
          null: "You must provide a name",
        },
        etternavn: {
          ikke: {
            null: "You must provide a last name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Last name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        fornavn: {
          ikke: {
            null: "You must provide a first name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "First name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
        mellomnavn: {
          ikke: {
            null: "You must provide a middle name",
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Middle name is too long, max length is {{messageParams.maxLength}} characters",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "You must provide birth or D-number.",
        },
        gyldig: {
          foedselsEllerDnummer:
            "This is not a valid Norwegian birth or D-number",
        },
      },
    },
    andreErVitne: {
      ikke: {
        null: "You must answer whether you have the contact information of other witnesses",
      },
    },
    anmelderErVitne: {
      ikke: {
        null: "You must answer whether you yourself witnessed the incident",
      },
    },
  },
  hendelsesbeskrivelse: {
    handlinger: {
      tyveri: {
        gjenstander: {
          harForsikring: {
            ikke: {
              null: "You must answer whether you have insurance",
            },
          },
          forsikring: {
            ikke: {
              null: "You must fill in insurance information",
            },
            forsikringsselskap: {
              maaFylleUtVirksomhet: "You must provide an insurance company",
            },
            polisenummer: {
              ikke: {
                null: "You must provide your policy number",
                blank: "You must provide your policy number",
              },
              maks: {
                lengde:
                  "The policy number is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          handelsvarer: {
            varer: {
              antall: {
                stoerre: {
                  enn: "Amount must be greater than {{messageParams.value}}",
                },
                ikke: {
                  null: "You must provide the amount",
                },
              },
              pris: {
                ikke: {
                  null: "You must enter a price for the item",
                },
                stoerre: {
                  eller: {
                    lik: "Price must be greater than or equal to {{messageParams.value}}",
                  },
                },
              },
              navn: {
                ikke: {
                  null: "You must enter type and brand of the item",
                  blank: "Item name cannot consist of only blank characters",
                },
                maks: {
                  lengde: "The item name is too long.",
                },
              },
              ikke: {
                tom: "You must add an item",
                null: "You must add an item",
              },
            },
          },
          kjoeretoey: {
            kjoeretoeyInfo: {
              aarsmodell: {
                stoerre: {
                  enn: "The production year must be greater than {{messageParams.value}}",
                },
                ikke: {
                  null: "You must provide the production year of the vehicle",
                },
              },
              farge: {
                ikke: {
                  blank: "The color cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "The vehicle color description is too long, maximum length is {{messageParams.maxLength}} characters",
                },
              },
              merke: {
                ikke: {
                  null: "You must provide a brand name",
                  blank: "The brand cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "Brand name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              modell: {
                ikke: {
                  null: "You must provide the model of your vehicle",
                  blank: "The model cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "The vehicle model name is too long, the maximum length is {{messageParams.maxLength}} characters.",
                },
              },
              kjoeretoeyType: {
                ikke: {
                  null: "You must specify what type of vehicle it is",
                },
              },
              understellsnummer: {
                ikke: {
                  blank: "The VIN cannot consist of only empty characters",
                  null: "You must provide a VIN",
                },
                maks: {
                  lengde:
                    "VIN is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
            utenlandskRegistreringsnummer: {
              registreringsland: {
                ikke: {
                  blank: "The country cannot consist of only empty characters",
                  null: "You must provide the country of registration",
                },
                maks: {
                  lengde:
                    "Registration country is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              registreringslandIsoAlpha3: {
                ikke: {
                  blank: "The country cannot consist of only empty characters",
                  null: "You must provide the country of registration",
                },
                maks: {
                  lengde:
                    "Registration country is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              registreringsnummer: {
                ikke: {
                  null: "You must provide a registration number",
                  blank:
                    "The registration number cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "Registration number is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
            norskRegistreringsnummer: {
              ikke: {
                null: "You must search for the registration number",
                blank:
                  "The registration number cannot consist of only empty characters",
              },
              maks: {
                lengde:
                  "Registration number is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
          },
          beskrivelse: {
            ikke: {
              blank: "The description cannot consist of only empty characters",
              null: "You must provide a description of the item",
            },
            maks: {
              lengde:
                "Item description is too long, maximum length is {{messageParams.maxLength}} characters",
            },
          },
          ikke: {
            tom: "You must add at least one stolen item",
            null: "You must provide one or more items",
          },
          kjennemerke: {
            antallSkilt: {
              ikke: {
                null: "You must specify the number of plates",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "You must provide a license plate number",
              },
              min: {
                lengde:
                  "Identifier is too short, minimum length is {{messageParams.minLength}} characters",
              },
              maks: {
                lengde:
                  "Identifier is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          gjenstandType: {
            ikke: {
              null: "You must specify what type of item it is",
            },
          },
          mobiltelefon: {
            telefonnummer: {
              gyldig: {
                telefonnummer: "You must provide a valid phone number.",
              },
              ikke: {
                null: "You must provide a phone number",
              },
              maks: {
                lengde:
                  "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
            merke: {
              ikke: {
                null: "You must provide a brand name",
                blank: "You must provide a brand name",
              },
              maks: {
                lengde:
                  "Brand name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            modell: {
              ikke: {
                null: "You must provide a model name",
                blank: "Model name cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Model name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            teleselskap: {
              ikke: {
                blank:
                  "Telecom company cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Telecom company is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            imei: {
              ikke: {
                blank: "IMEI cannot consist of only blank characters",
              },
              gyldig: {
                imei: "IMEI is not valid",
              },
              maks: {
                lengde: "IMEI number is too long",
              },
              min: {
                lengde: "IMEI number is too short",
              },
              ugyldig: {
                moenster: "IMEI can only contain numbers",
              },
            },
          },
          fartoy: {
            watercraftIdentificationNumber: {
              ugyldigWIN: "You must provide a valid WIN",
            },
            lengde: {
              ikke: {
                null: "You must provide the length of the vessel",
              },
              stoerre: {
                eller: {
                  lik: "The vessel length must be greater than or equal to {{messageParams.value}}",
                },
              },
              maks: {
                lengde: "The vessel is too long",
              },
            },
            merke: {
              ikke: {
                null: "You must provide a brand name",
              },
              maks: {
                lengde: "Brand name is too long",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "You must provide the registration number of the vessel",
              },
              maks: {
                lengde: "The registration number is too long.",
              },
            },
            skrogtype: {
              ikke: {
                null: "You must specify the hull type of the vessel",
              },
            },
            type: {
              ikke: {
                null: "You must specify what type of vessel it is",
              },
            },
            modell: {
              maks: {
                lengde: "The vessel model name is too long.",
              },
            },
          },
          sykkel: {
            merke: {
              ikke: {
                null: "You must provide a brand name",
                blank: "Brand name cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Brand name is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            modell: {
              ikke: {
                blank: "Model name cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "The model name of the bike is too long, the maximum length is {{messageParams.maxLength}} characters.",
              },
            },
            type: {
              ikke: {
                null: "You must specify what type of bicycle it is",
              },
            },
            rammenummer: {
              ikke: {
                blank: "Frame number cannot consist of only blank characters.",
              },
              maks: {
                lengde:
                  "The frame number is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          pris: {
            ikke: {
              null: "You must provide a price for the stolen item",
            },
            lik: "Price must be equal to {{messageParams.value}}",
            stoerre: {
              eller: {
                lik: "Price must be greater than or equal to {{messageParams.value}}",
              },
            },
          },
          elektronikk: {
            type: {
              ikke: {
                null: "You must specify what type of electronics it is",
              },
            },
            merke: {
              ikke: {
                null: "You must provide a brand name",
                blank: "Brand name cannot consist of only blank characters",
              },
              maks: {
                lengde: "Brand name is too long",
              },
            },
            modell: {
              ikke: {
                null: "You must provide the model of the electronic item",
                blank: "Model name cannot consist of only blank characters",
              },
              maks: {
                lengde: "The model name of the electronic item is too long",
              },
            },
            serienummer: {
              ikke: {
                blank: "Serial number cannot consist of only blank characters",
              },
              maks: {
                lengde: "The serial number is too long.",
              },
            },
          },
          verktoy: {
            type: {
              ikke: {
                null: "You must specify the type of tool",
              },
            },
            merke: {
              ikke: {
                null: "You must specify the brand of the tool",
                blank: "Brand cannot consist of only blank characters",
              },
              maks: {
                lengde: "The brand of the tool is too long",
              },
            },
            modell: {
              ikke: {
                null: "You must specify the model of the tool",
                blank: "Model cannot consist of only blank characters",
              },
              maks: {
                lengde: "The model name of the tool is too long",
              },
            },
            serienummer: {
              ikke: {
                blank: "Serial number cannot consist of only blank characters",
              },
              maks: {
                lengde: "The serial number is too long",
              },
            },
          },
        },
      },
      skadeverk: {
        gjenstander: {
          kjoeretoey: {
            kjoeretoeyInfo: {
              aarsmodell: {
                stoerre: {
                  enn: "The production year must be greater than {{messageParams.value}}",
                },
                ikke: {
                  null: "You must provide the production year of the vehicle",
                },
              },
              farge: {
                ikke: {
                  blank: "The color cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "The vehicle color description is too long, maximum length is {{messageParams.maxLength}} characters",
                },
              },
              merke: {
                ikke: {
                  null: "You must provide a brand name",
                  blank: "The brand cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "Brand name is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              modell: {
                ikke: {
                  null: "You must provide the model of your vehicle",
                  blank: "The model cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "The vehicle model name is too long, the maximum length is {{messageParams.maxLength}} characters.",
                },
              },
              kjoeretoeyType: {
                ikke: {
                  null: "You must specify what type of vehicle it is",
                },
              },
              understellsnummer: {
                ikke: {
                  blank: "The VIN cannot consist of only empty characters",
                  null: "You must provide a VIN",
                },
                maks: {
                  lengde:
                    "VIN is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
            utenlandskRegistreringsnummer: {
              registreringsland: {
                ikke: {
                  blank: "The country cannot consist of only empty characters",
                  null: "You must provide the country of registration",
                },
                maks: {
                  lengde:
                    "Registration country is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              registreringslandIsoAlpha3: {
                ikke: {
                  blank: "The country cannot consist of only empty characters",
                  null: "You must provide the country of registration",
                },
                maks: {
                  lengde:
                    "Registration country is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              registreringsnummer: {
                ikke: {
                  null: "You must provide a registration number",
                  blank:
                    "The registration number cannot consist of only empty characters",
                },
                maks: {
                  lengde:
                    "Registration number is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
            norskRegistreringsnummer: {
              ikke: {
                null: "You must search for the registration number",
                blank:
                  "The registration number cannot consist of only empty characters",
              },
              maks: {
                lengde:
                  "Registration number is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
          },
          beskrivelse: {
            ikke: {
              blank: "The description cannot consist of only empty characters",
              null: "You must provide a description of the damage",
            },
            maks: {
              lengde:
                "Damage description is too long, max length is {{messageParams.maxLength}} characters",
            },
          },
          ikke: {
            tom: "You must add at least one damaged item",
            null: "You must provide one or more items",
          },
          gjenstandType: {
            ikke: {
              null: "You must specify what type of item it is",
            },
          },
          fartoy: {
            watercraftIdentificationNumber: {
              ugyldigWIN: "You must provide a valid WIN",
            },
            lengde: {
              ikke: {
                null: "You must provide the length of the vessel",
              },
              stoerre: {
                eller: {
                  lik: "The vessel length must be greater than or equal to {{messageParams.value}}",
                },
              },
              maks: {
                lengde: "The vessel is too long",
              },
            },
            merke: {
              ikke: {
                null: "You must provide a brand name",
              },
              maks: {
                lengde: "Brand name is too long",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "You must provide the registration number of the vessel",
              },
              maks: {
                lengde: "The registration number is too long.",
              },
            },
            skrogtype: {
              ikke: {
                null: "You must specify the hull type of the vessel",
              },
            },
            type: {
              ikke: {
                null: "You must specify what type of vessel it is",
              },
            },
            modell: {
              maks: {
                lengde: "The vessel model name is too long.",
              },
            },
          },
          formuestap: {
            ikke: {
              null: "You must provide the value of the damaged property",
            },
            stoerre: {
              eller: {
                lik: "The value must be greater than or equal to {{messageParams.value}}",
              },
            },
          },
        },
      },
      innbrudd: {
        beskrivelse: {
          ikke: {
            blank: "The description cannot consist of only empty characters",
            null: "You must provide a description of the burglary",
          },
          maks: {
            lengde:
              "Description of incident is too long, maximum length is {{messageParams.maxLength}} characters",
          },
        },
      },
      bedrageri: {
        bedragerimetode: {
          ikke: {
            null: "You must provide a fraud method",
          },
          innledendeKontakt: {
            ikke: {
              null: "You must answer how you first came into contact with the scammer",
            },
            beskrivelse: {
              ikke: {
                null: "You must answer how you first came into contact with the scammer",
                blank:
                  "The description cannot consist of only empty characters",
              },
              maks: {
                lengde:
                  "Description is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
          },
          hvaSkjeddeBedrageriMetode: {
            ikke: {
              null: "You must answer what happened in the fraud",
            },
            moettSvindlerFysisk: {
              ikke: {
                null: "You must answer whether you physically met the scammer",
              },
            },
            harDuMottattLenke: {
              ikke: {
                null: "You must answer whether you received a link",
              },
            },
            lenke: {
              ikke: {
                null: "You must provide a link",
                blank: "The link cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "The link is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            harInstallertProgramEllerApp: {
              ikke: {
                null: "You must answer whether you have installed a program or app",
              },
            },
            hvilketProgramEllerApp: {
              ikke: {
                null: "You must answer which program or app you installed",
                blank:
                  "Installed program or app cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Installed program or app is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            paaHvilkenEnhet: {
              ikke: {
                null: "You must pick one of the options",
              },
            },
          },
        },
        tilegnedeVerdier: {
          ikke: {
            null: "You must answer what the scammer has obtained",
            tom: "You must answer what the scammer has obtained",
          },
          type: {
            ikke: {
              null: "You must answer what the scammer has obtained",
            },
          },
          annenTilegnetVerdi: {
            ikke: {
              null: "You must answer what other value the scammer has obtained",
            },
            beskrivelse: {
              ikke: {
                null: "You must describe what other value the scammer has obtained",
                blank:
                  "You must describe what other value the scammer has obtained",
              },
              maks: {
                lengde:
                  "Description is too long, max length is {{messageParams.maxLength}} characters",
              },
            },
            sum: {
              ikke: {
                null: "You must specify which value the scammer has obtained",
              },
              stoerre: {
                eller: {
                  lik: "The sum must be greater than or equal to {{messageParams.value}}",
                },
              },
            },
          },
          personinformasjon: {
            ikke: {
              null: "You must add personal information",
            },
            personinformasjonTypeListe: {
              ikke: {
                null: "You must answer what the scammer has obtained",
                tom: "You must answer what the scammer has obtained",
              },
            },
            annetBeskrivelse: {
              ikke: {
                null: "You must describe what kind of personal information the scammer has obtained",
                blank:
                  "What kind of personal information the scammers have obtained cannot consist of just blank characters",
              },
              maks: {
                lengde:
                  "Description of personal information is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          kode: {
            ikke: {
              null: "You must add code",
            },
            beskrivelse: {
              ikke: {
                null: "You must answer what the code was for",
                blank:
                  "What the code was for cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Description of what the code was for is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          passord: {
            ikke: {
              null: "You must add password",
            },
            beskrivelse: {
              ikke: {
                null: "You must answer what the password was for",
                blank:
                  "What the password was for cannot consist of only blank characters",
              },
              maks: {
                lengde:
                  "Description of what the password was for is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          fysiskId: {
            ikke: {
              null: "You must add physical identification",
            },
            fysiskIdTypeListe: {
              ikke: {
                null: "You must answer what kind of physical ID the scammers have obtained",
                tom: "You must answer what kind of physical ID the scammers have obtained",
              },
            },
            annetBeskrivelse: {
              ikke: {
                null: "You must describe what kind of physical identification the scammer has obtained",
                blank: "Physical ID cannot consist of just blank characters",
              },
              maks: {
                lengde:
                  "Description of physical ID is too long, maximum length is {{messageParams.maxLength}} characters",
              },
            },
          },
          penger: {
            ikke: {
              null: "You must add a transaction",
              tom: "You must add a transaction",
            },
            fratattSum: {
              ikke: {
                null: "You must answer how much money you were deprived of",
              },
              stoerre: {
                eller: {
                  lik: "The sum must be greater than or equal to {{messageParams.value}}",
                },
              },
            },
            overforing: {
              ikke: {
                null: "Transfer cannot be zero",
              },
              type: {
                ikke: {
                  null: "You must answer how you were deprived of money",
                },
              },
              kontooverforing: {
                ikke: {
                  null: "You must add an account transfer",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "You must provide a valid Norwegian account number or IBAN/BIC for international account numbers",
                  },
                  ikke: {
                    blank: "The text cannot consist of only blank characters.",
                    null: "You must answer which account the money was taken from",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                tilKontonummer: {
                  gyldig: {
                    kontonummer:
                      "You must provide a valid Norwegian account number or IBAN/BIC for international account numbers",
                  },
                  ikke: {
                    null: "You must answer which account the money went to",
                    blank: "The text cannot consist of only blank characters.",
                    lik: {
                      verdi: "From account and to account cannot be the same",
                    },
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "You must answer which bank the money was taken from",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
              },
              vippsoverforing: {
                ikke: {
                  null: "You must add a Vipps transfer",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "You must provide a valid Norwegian account number or IBAN/BIC for international account numbers",
                  },
                  ikke: {
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                fraTelefonnummer: {
                  gyldig: {
                    telefonnummer: "You must provide a valid phone number.",
                  },
                  ikke: {
                    null: "You must answer which phone number the money went from",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                tilTelefonnummer: {
                  gyldig: {
                    telefonnummer: "You must provide a valid phone number.",
                  },
                  ikke: {
                    null: "You must answer which phone number the money went to",
                    blank: "The text cannot consist of only blank characters.",
                    lik: {
                      verdi:
                        "From phone number and to phone number cannot be the same",
                    },
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "You must answer which bank the money was taken from",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                mottaker: {
                  ikke: {
                    null: "You must provide the name of the recipient",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
              },
              kryptooverforing: {
                ikke: {
                  null: "You must add a crypto transfer",
                },
                valuta: {
                  ikke: {
                    null: "You must specify which cryptocurrency was transferred",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                belop: {
                  ikke: {
                    null: "You must enter the amount in the currency used",
                  },
                  stoerre: {
                    enn: "Amount must be greater than {{messageParams.value}}",
                  },
                },
                fraAdresse: {
                  ikke: {
                    null: "You must answer which cryptocurrency address the money went from",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                tilAdresse: {
                  ikke: {
                    null: "You must answer which cryptocurrency address the money went to",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                vekslingstjeneste: {
                  ikke: {
                    null: "You must answer which crypto exchange service was used",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                transaksjonsId: {
                  ikke: {
                    null: "You must provide the transaction ID",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
              },
              kortbetaling: {
                ikke: {
                  null: "You must add a card payment",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "You must provide a valid Norwegian account number or IBAN/BIC for international account numbers",
                  },
                  ikke: {
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                kortnummer: {
                  gyldig: {
                    kortnummer: "You must enter a valid card number",
                  },
                  ikke: {
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "You must answer which bank the money was taken from",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
                mottaker: {
                  ikke: {
                    null: "You must provide the recipient of the payment",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
              },
              annetoverforing: {
                ikke: {
                  null: "You must add a transfer",
                },
                beskrivelse: {
                  ikke: {
                    null: "You must describe how the money was taken and where it went",
                    blank: "The text cannot consist of only blank characters.",
                  },
                  maks: {
                    lengde:
                      "Text is too long, max length is {{messageParams.maxLength}} characters",
                  },
                },
              },
            },
            selvOverfort: {
              ikke: {
                null: "You must answer whether you transferred the money yourself",
              },
              harDuSelvOverfortPengene: {
                ikke: {
                  null: "You must answer whether you transferred the money yourself",
                },
              },
              overforingFormaal: {
                ikke: {
                  null: "You must answer what the purpose of the transfer was",
                },
              },
              annetOverforingFormaalBeskrivelse: {
                ikke: {
                  null: "You must describe what the purpose of the transfer was",
                  blank: "The text cannot consist of only blank characters.",
                },
                maks: {
                  lengde:
                    "Text is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
              erOverforingGodkjentMedPassordEtc: {
                ikke: {
                  null: "You must answer whether you have approved transfers by entering a code or password",
                },
              },
            },
            bankenStansetOverforing: {
              ikke: {
                null: "You must answer whether your bank has stopped the transfer",
              },
              harBankenStansetOverforingen: {
                ikke: {
                  null: "You must answer whether your bank has stopped the transfer",
                },
              },
              hvorMyeHarBankenStanset: {
                ikke: {
                  null: "You must answer how much the bank has stopped",
                },
                stoerre: {
                  enn: "Must be greater than {{messageParams.value}}",
                },
                mindre: {
                  enn: "Must be less than the sum of the transaction",
                },
              },
            },
            tilbakeforing: {
              ikke: {
                null: "You must answer whether you have received your money back",
              },
              type: {
                ikke: {
                  null: "You must answer whether you have received your money back",
                },
              },
              hvorMyeHarFornaermedeFaattTilbake: {
                ikke: {
                  null: "You must answer how much the victim has received back",
                },
                stoerre: {
                  enn: "Must be greater than {{messageParams.value}}",
                },
                mindre: {
                  enn: "Must be less than the sum of the transaction",
                },
              },
              hvemHarFornaermedeFaattPengerFra: {
                ikke: {
                  null: "You must state who you received the refund from",
                  blank: "The text cannot consist of only blank characters.",
                },
                maks: {
                  lengde:
                    "Text is too long, max length is {{messageParams.maxLength}} characters",
                },
              },
            },
          },
        },
        etterBedrageriet: {
          ikke: {
            null: "You must explain what happened after the fraud",
          },
          vetBankenOmBedrageriet: {
            ikke: {
              null: "You must answer whether you your bank knows about the incident",
            },
          },
          erFornaermedesKortSperret: {
            ikke: {
              null: "You must answer whether your card is blocked",
            },
          },
          erFornaermedesKontoSperret: {
            ikke: {
              null: "You must answer whether your account is blocked",
            },
          },
        },
      },
      datakrim: {
        hvaSkjedde: {
          ikke: {
            null: "You must check at least one description",
          },
          datakrimHendelser: {
            ikke: {
              tom: "You must check at least one description",
              null: "You must check at least one description",
            },
          },
          beskrivelse: {
            ikke: {
              null: "You must briefly describe what happened",
              blank: "Cannot consist of only blank characters",
            },
            maks: {
              lengde:
                "Description is too long, maximum length is {{messageParams.maxLength}} characters",
            },
          },
        },
        dataPaAvveie: {
          ikke: {
            null: "You must answer whether you believe that data has been compromised",
          },
          svar: {
            ikke: {
              null: "You must answer whether you believe that data has been compromised",
            },
          },
          beskrivelse: {
            ikke: {
              null: "You must explain why you believe data has been compromised",
              blank: "Cannot consist of only blank characters",
            },
            maks: {
              lengde:
                "Description is too long, maximum length is {{messageParams.maxLength}} characters",
            },
          },
        },
        andreMyndigheterVarslet: {
          ikke: {
            null: "You must answer whether other organisations or authorities have been notified or are involved",
          },
          svar: {
            ikke: {
              null: "You must answer whether other organisations or authorities have been notified or are involved",
            },
          },
          beskrivelse: {
            ikke: {
              null: "You must state which authorities or organisations have been notified or are involved",
              blank: "Cannot consist of only blank characters",
            },
            maks: {
              lengde:
                "Description is too long, maximum length is {{messageParams.maxLength}} characters",
            },
          },
        },
        tilleggsinformasjon: {
          ikke: {
            blank: "Cannot consist of only blank characters",
          },
          maks: {
            lengde:
              "Additional information is too long, maximum length is {{messageParams.maxLength}} characters",
          },
        },
      },
      ikke: {
        tom: "You must answer what happened",
      },
    },
    beskrivelse: {
      ikke: {
        blank: "The description cannot consist of only empty characters",
        null: "You must explain how the incident happened",
      },
      maks: {
        lengde:
          "Description of incident is too long, maximum length is {{messageParams.maxLength}} characters",
      },
    },
  },
  erstatningskrav: {
    beskrivelseErstatningskrav: {
      ikke: {
        blank: "The description cannot consist of only empty characters",
        null: "You must describe what you are claiming compensation for",
      },
      maks: {
        lengde:
          "Description of compensation claim is too long, max length is {{messageParams.maxLength}} characters",
      },
    },
    ikke: {
      null: "You must answer whether you wish to file a claim for compensation",
    },
    erstatningskravSvarType: {
      ikke: {
        null: "You must answer whether you wish to file a claim for compensation",
      },
    },
    fullmakt: {
      ikke: {
        null: "You must upload a power of attorney in order to file a claim for compensation",
      },
    },
  },
  hendelsessted: {
    utenlandskAdresse: {
      ikke: {
        null: "You must provide a location",
      },
      landkodeAlpha3: {
        ikke: {
          null: "You must provide a country",
          blank: "You must provide a country",
        },
        maks: {
          lengde:
            "Country code is too long, max length is {{messageParams.maxLength}} characters",
        },
        landKode: "Invalid country",
      },
      adresselinje: {
        ikke: {
          blank: "The text cannot consist of only blank characters.",
        },
        maks: {
          lengde:
            "Address is too long, max length is {{messageParams.maxLength}} characters",
        },
      },
      postnummer: {
        ikke: {
          blank: "Postal number cannot consist of only blank characters",
        },
        maks: {
          lengde:
            "Postal code is too long, max length is {{messageParams.maxLength}} characters",
        },
      },
      poststed: {
        ikke: {
          blank: "Place cannot consist of only blank characters",
        },
        maks: {
          lengde:
            "Postal place is too long, max length is {{messageParams.maxLength}} characters",
        },
      },
    },
    ikkeFysiskSted: {
      ikke: {
        null: "You must describe where it happened",
      },
      beskrivelse: {
        ikke: {
          null: "You must describe where it happened",
          blank: "The text cannot consist of only blank characters.",
        },
        maks: {
          lengde:
            "Website is too long, max length is {{messageParams.maxLength}} characters",
        },
      },
    },
    matrikkeladresse: {
      ikke: {
        null: "You must provide a location",
      },
      validKartverketAdresse:
        "Unable to validate the address against the Norwegian Mapping Authority",
    },
    vegadresse: {
      ikke: {
        null: "You must provide a location",
      },
      validKartverketAdresse:
        "Unable to validate the address against the Norwegian Mapping Authority",
    },
    stedsnavn: {
      ikke: {
        null: "You must provide a location",
      },
      validKartverketStedsnavn:
        "Unable to validate the location name against the Norwegian Mapping Authority",
      beskrivelse: {
        ikke: {
          null: "You must provide a description of the location",
          blank: "The description cannot consist of only empty characters",
        },
        maks: {
          lengde:
            "Description of crime scene is too long, maximum length is {{messageParams.maxLength}} characters",
        },
      },
    },
    kartpunkt: {
      ikke: {
        null: "You must provide a location",
      },
      beskrivelse: {
        ikke: {
          null: "You must provide a description of the location",
          blank: "The description cannot consist of only empty characters",
        },
        maks: {
          lengde:
            "Description of crime scene is too long, maximum length is {{messageParams.maxLength}} characters",
        },
      },
      koordinat: {
        ikke: {
          null: "Click on the map to indicate where it happened",
        },
        koordinatUtenforNorge:
          "The point appears to be in the ocean or outside Norway's borders. Please select a point on land in Norway.",
        lat: {
          ikke: {
            null: "Click on the map to indicate where it happened",
          },
          mellom:
            "Latitude must be between {{messageParams.start}} and {{messageParams.end}}",
        },
        lon: {
          ikke: {
            null: "Click on the map to indicate where it happened",
          },
          mellom:
            "Longitude must be between {{messageParams.start}} and {{messageParams.end}}",
        },
      },
    },
    hendelsesstedValg: {
      ikke: {
        null: "You must provide a location",
        lik: {
          verdi: "You must provide a location",
        },
      },
    },
    stedtype: {
      ikke: {
        null: "You must state where the offense occurred",
      },
    },
  },
  bekreftelseAvAnsvarSomAnmelder: {
    ikke: {
      null: "To submit the report you must confirm that you understand your responsibility as a reporter of a crime",
    },
    true: "To submit the report you must confirm that you understand your responsibility as a reporter of a crime",
  },
  anmelder: {
    navn: {
      ikke: {
        null: "Could not retrieve your name from the National Population Register",
      },
    },
    kontaktopplysninger: {
      epost: {
        ikke: {
          null: "You must provide an email address",
        },
        gyldig: {
          epost: "You must provide a valid email address",
        },
        maks: {
          lengde:
            "The email address is too long, the maximum length is {{messageParams.maxLength}} characters.",
        },
      },
      telefonnummer: {
        gyldig: {
          telefonnummer: "You must provide a valid phone number.",
        },
        ikke: {
          null: "You must provide a phone number",
        },
        maks: {
          lengde:
            "The phone number is too long, maximum length is {{messageParams.maxLength}} characters",
        },
      },
    },
  },
  maaFylleUtVirksomhet: "You must choose an enterprise",
};
export default valideringsmeldinger;
